/**
 * Retorna la URL base del backend según el entorno.
 * - Producción / Capacitor nativo → siempre el servidor real
 * - Desarrollo local → REACT_APP_BACKEND_URL o localhost:8001
 */
const isNative = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();
const isProd = process.env.NODE_ENV === 'production';

const BACKEND_URL =
  isProd || isNative
    ? process.env.REACT_APP_BACKEND_URL && !process.env.REACT_APP_BACKEND_URL.includes('localhost')
      ? process.env.REACT_APP_BACKEND_URL
      : 'https://pgastos.capacitatu.com'
    : process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export default BACKEND_URL;
